export const addDecimals = (num) => {
    return (Math.round(num*100)/100).toFixed(2);
}

export const updateCart = (state) => {
    // Calculate the items and items price tax
    state.itemsPrice = addDecimals(state.cartItems.reduce((acc, item) => acc + item.customization.priceCustomization[item.selectedPriceCustomization].price*item.quantity, 0));
    state.taxPrice = state.noFeeShippingTax ? 0 : addDecimals((0.05*Number(state.itemsPrice)));

    // // Calculate the shipping price and shipping price tax (if order is over ₹1000 then ₹30 shipping, if over ₹500 then ₹40 shipping, else ₹50 shipping)
    state.shippingPrice = state.noFeeShippingTax ? 0 : addDecimals(Number(state.itemsPrice) >= 1000 ? 30 : Number(state.itemsPrice) >= 500 ? 40 : 50);
    state.shippingTax = state.shippingPrice * 0.05;

    // Calculate platform fee and platform fee tax
    state.platformFee = state.noFeeShippingTax ? 0 : addDecimals(2);
    state.platformFeeTax = addDecimals(state.platformFee*0.18);

    state.taxAndFees = addDecimals(Number(state.taxPrice) + Number(state.shippingTax) + Number(state.platformFee) + Number(state.platformFeeTax));

    // Calculate total price
    state.totalPrice = addDecimals(Number(state.itemsPrice) + Number(state.shippingPrice) + Number(state.taxAndFees));

    // Save to local storage
    localStorage.setItem('cart', JSON.stringify(state));

    return state;
}